module.exports = __webpack_public_path__ + "static/img/wx_yd.d11f5894.png";